import { useMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { AllWorkflows } from "@circle-react/components/SettingsApp/Workflows/routes/AllWorkflows";
import { TabContainer } from "../../components/TabContainer";
import { usePaywallFormContext } from "../PaywallFormProvider";

export const WorkflowsTab = () => {
  const isMdScreen = useMdScreenMediaQuery();
  const { onClose } = usePaywallFormContext();

  return (
    <TabContainer className="-mx-6 -mt-4">
      <AllWorkflows
        category="paywalls"
        pageSize={isMdScreen ? 4 : 3}
        onClose={onClose}
        shouldAutoAdjust
      />
    </TabContainer>
  );
};
